import { RoleEnum } from './../../enums/role.enum';
import moment from 'moment';
import { IUserInformation } from './auth-store.interface';

const getters = {
    LAST_VISITED_DATE: (state: any) => {
        if (!state.userInformation.lastVisitDateTimeUTC) return moment.utc();
        
        return moment.utc((state.userInformation as IUserInformation).lastVisitDateTimeUTC);
    },
    USER_IS_DOCTOR: (state: any) => {
        return (state.userInformation as IUserInformation).userdata.toLowerCase() === RoleEnum.Doctor.toLowerCase();
    }
};

export default getters;
